<template>
  <div class="hot_div">
    <div class="hot_list">
      <div class="list_describe">
        {{total}}条评论
      </div>
      <div
        class="hot_li"
        v-for="(liem,index) in list"
      >
        <div class="li_title flex_between">
          <div class="name flex_center">
            <img
              :src="liem.image"
              alt=""
            >
            <h2>{{liem.name}}</h2>
          </div>
          <span class="time">{{liem.create_time}}</span>
        </div>
        <div
          class="li_center"
          v-if="liem.type == 1"
        >
          <span v-html="liem.content"></span>
        </div>
        <div
          class="li_center li_r_img"
          v-if="liem.type == 2"
        >
          <img
            :src="liem.content"
            alt=""
          >
        </div>
        <div class="li_button flex_between">
          <a
            class="flex_center"
            href="javaScript:vido(0)"
            @click.stop="give(index)"
          >
            <i><img
                src="@/assets/img/dianzhanP.png"
                alt=""
              ></i>
            {{liem.goods}}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'popup',
  data () {
    return {
    }
  },
  props: {
    total: {
      type: Number
    },
    list: {
      type: Array,
    }
  },
  watch: {
    list: function () {
      let that = this;
      setTimeout(() => {
        that.addImg();
      }, 500)
    }
  },
  methods: {
    give (index) {
      let that = this;
      this.$post('comment_goods', { comment_id: this.list[index].comment_id }).then(res => {
        that.list[index].goods = res.data;
      })
    },
    addImg () {
      $('.li_r_img img').on("click", function () {
         
        $(this).ImgZoomIn('');
      });
    },

  },
  mounted () {
    this.addImg();
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hot_div {
  width: 100%;
}

.hot_list {
  padding: 0 23px;
  border: 1px solid #dfdfdf;
  border-radius: 4px;
}

.hot_list .list_describe {
  height: 40px;
  border-bottom: 1px solid #dfdfdf;
  color: #333;
  font-size: 14px;
  line-height: 40px;
  margin-bottom: 17px;
}

.hot_list .hot_li {
  margin-bottom: 23px;
}

.hot_list .hot_li .li_title .name > img {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  object-fit: contain;
  margin-right: 8px;
}

.hot_list .hot_li .li_title .name > h2 {
  font-size: 18px;
  color: #3e8cde;
}

.hot_list .hot_li .li_title .time {
  font-size: 12px;
  color: #666;
}

.hot_list .hot_li .li_center {
  font-size: 15px;
  color: #1a1a1a;
  line-height: 1.6em;
  margin: 8px 0;
  word-wrap: break-word;
  word-break: break-all;
}

.hot_list .hot_li .li_center img {
  max-width: 50%;
  cursor: pointer;
}

.hot_list .hot_li .li_button > a {
  font-size: 14px;
  color: #999;
}

.hot_list .hot_li .li_button > a > i {
  width: 15px;
  margin-right: 2px;
}
</style>


// WEBPACK FOOTER //
// src/components/assembly/comments_li.vue